<!-- BEGIN #sidebar -->
<div id="sidebar" class="app-sidebar" [attr.data-bs-theme]="appSettings.appSidebarLight ? '' : 'dark'" [ngClass]="{ 
	'app-sidebar-transparent': this.appSidebarTransparent,'app-sidebar-grid': this.appSidebarGrid}">

  <div class="logo-container">
    <img src="assets/icons/logo.png" alt="Logo" class="sidebar-logo" />
    <div class="universe">Universe</div>
  </div>

  <!-- BEGIN scrollbar -->
  <ng-scrollbar class="app-sidebar-content" [ngClass]="{ 'h-100': appSettings.appSidebarFixed }" #sidebarScrollbar
    (scroll)="onScroll($event)">
    <ng-container *ngTemplateOutlet="sidebarNav"></ng-container>
  </ng-scrollbar>
  <!-- END scrollbar -->

  <ng-template #sidebarNav>
    <!-- BEGIN menu -->
    <div class="menu">
      <div class="menu-item menu-profile" *ngIf="!appSettings.appSidebarSearch">
        <a href="javascript:;" class="menu-profile-link" (click)="toggleNavProfile($event)">
          <div class="menu-profile-cover with-shadow"></div>
          <div class="menu-profile-image menu-profile-image-icon bg-gray-900 text-gray-600">
            <i class="fa fa-user"></i>
          </div>
          <div class="menu-profile-info">
            <div class="d-flex align-items-center">
              <div class="flex-grow-1">
                Sean Ngu
              </div>
              <div class="menu-caret ms-auto"></div>
            </div>
            <small>Front end developer</small>
          </div>
        </a>
      </div>
      <div id="appSidebarProfileMenu" class="collapse" *ngIf="!appSettings.appSidebarSearch">
        <div class="menu-item pt-5px">
          <a href="javascript:;" class="menu-link">
            <div class="menu-icon"><i class="fa fa-cog"></i></div>
            <div class="menu-text">Settings</div>
          </a>
        </div>
        <div class="menu-item">
          <a href="javascript:;" class="menu-link">
            <div class="menu-icon"><i class="fa fa-pencil-alt"></i></div>
            <div class="menu-text"> Send Feedback</div>
          </a>
        </div>
        <div class="menu-item pb-5px">
          <a href="javascript:;" class="menu-link">
            <div class="menu-icon"><i class="fa fa-question-circle"></i></div>
            <div class="menu-text"> Helps</div>
          </a>
        </div>
        <div class="menu-divider m-0"></div>
      </div>

      <div class="menu-search mb-n3" *ngIf="appSettings.appSidebarSearch">
        <input type="text" class="form-control" placeholder="Sidebar menu filter..."
          (keyup)="appSidebarSearch($event)" />
      </div>
      <div class="menu-header">Navigation</div>

      <!-- render sidebarMenuNav -->
      <ng-template #sidebarMenuNav let-menu="menu">
        <div class="menu-icon-img" *ngIf="menu.img && hasAccessibleChildItems(menu)"><img src="{{ menu.img }}" /></div>
        <div class="menu-icon" *ngIf="menu.icon && hasAccessibleChildItems(menu)"><i class="{{ menu.icon }}"></i></div>
        <div class="menu-text" *ngIf="menu.title && hasAccessibleChildItems(menu)">
          {{ menu.title }}
          <span class="menu-label" *ngIf="menu.label && hasAccessibleChildItems(menu)">{{ menu.label }}</span>
        </div>
        <div class="menu-badge" *ngIf="menu.badge && hasAccessibleChildItems(menu)">{{ menu.badge }}</div>
        <div class="menu-caret" *ngIf="menu.caret && hasAccessibleChildItems(menu)"></div>
      </ng-template>

      <!-- render sidebarSubMenuNav -->
      <ng-template #sidebarSubMenuNav let-menu="menu">
        <div class="menu-text" *ngIf="menu.title">
          {{ menu.title }}
          <i class="fa fa-paper-plane text-theme ms-5px" *ngIf="menu.highlight"></i>
        </div>
        <div class="menu-caret" *ngIf="menu.caret"></div>
      </ng-template>

      <!-- sidebar menu -->

      <div class="menu-item" *ngFor="let menu of menus" routerLinkActive="active"
        [routerLinkActiveOptions]="{exact: true}"
        [ngClass]="{ 'expand': menu.state == 'expand', 'has-sub': menu.submenu, 'd-none': menu.hide }"
        #rla="routerLinkActive">
        <a class="menu-link" *ngIf="menu.submenu && hasAccessibleChildItems(menu)"
          (mouseenter)="showAppSidebarFloatSubMenu(menu.submenu, $event)" (mouseleave)="hideAppSidebarFloatSubMenu()">
          <ng-container *ngTemplateOutlet="sidebarMenuNav; context: {menu: menu}"></ng-container>
        </a>
        @if(menu?.isLogout){
        <a class="menu-link" *ngIf="menu?.isLogout" (click)="logoutUser()">
          <div class="menu-icon"><i class="{{ menu.icon }}"></i></div>
        </a>
        }@else if(!menu?.isLogout){
        <a class="menu-link" *ngIf="!menu.submenu && hasAccessibleChildItems(menu)" [routerLink]="menu.url">
          <ng-container *ngTemplateOutlet="sidebarMenuNav; context: {menu: menu}"></ng-container>
        </a>
        }

        <!-- submenu lvl 1 -->
        <div class="menu-submenu" *ngIf="menu.submenu"
          [style.display]="(menu.state == 'expand' && !appSettings.appSidebarMinified) ? 'block' : (menu.state == 'collapse') ? 'none' : ''">
          <div class="menu-item" *ngFor="let menu1 of menu.submenu" routerLinkActive="active"
            [routerLinkActiveOptions]="{exact: true}"
            [ngClass]="{ 'expand': menu1.state == 'expand', 'closed': menu1.state == 'collapsed', 'has-sub': menu1.submenu, 'd-none': menu1.hide }"
            #rla1="routerLinkActive">
            <a class="menu-link" *ngIf="menu1.submenu"
              (click)="(menu1.submenu) ? expandCollapseSubmenu(menu1, menu.submenu, rla1) : ''">
              <ng-template *ngTemplateOutlet="sidebarSubMenuNav; context: {menu: menu1}"></ng-template>
            </a>
            <a class="menu-link" *ngIf="!menu1.submenu" [routerLink]="menu1.url">
              <ng-template *ngTemplateOutlet="sidebarSubMenuNav; context: {menu: menu1}"></ng-template>
            </a>


            <!-- submenu lvl 2 -->
            <div class="menu-submenu" *ngIf="menu1.submenu"
              [style.display]="(menu1.state == 'expand' && !appSettings.appSidebarMinified) ? 'block' : (menu1.state == 'collapse') ? 'none' : ''">
              <div class="menu-item" *ngFor="let menu2 of menu1.submenu" routerLinkActive="active"
                [routerLinkActiveOptions]="{exact: true}"
                [ngClass]="{ 'expand': menu2.state == 'expand', 'closed': menu2.state == 'collapsed', 'has-sub': menu2.submenu, 'd-none': menu2.hide }"
                #rla2="routerLinkActive">
                <a class="menu-link" *ngIf="menu2.submenu"
                  (click)="(menu2.submenu) ? expandCollapseSubmenu(menu2, menu1.submenu, rla2) : ''">
                  <ng-template *ngTemplateOutlet="sidebarSubMenuNav; context: {menu: menu2}"></ng-template>
                </a>
                <a class="menu-link" *ngIf="!menu2.submenu" [routerLink]="menu2.url">
                  <ng-template *ngTemplateOutlet="sidebarSubMenuNav; context: {menu: menu2}"></ng-template>
                </a>

                <!-- submenu lvl 3 -->
                <div class="menu-submenu" *ngIf="menu2.submenu"
                  [style.display]="(menu2.state == 'expand' && !appSettings.appSidebarMinified) ? 'block' : (menu2.state == 'collapse') ? 'none' : ''">
                  <div class="menu-item" *ngFor="let menu3 of menu2.submenu" routerLinkActive="active"
                    [routerLinkActiveOptions]="{exact: true}"
                    [ngClass]="{ 'expand': menu3.state == 'expand', 'closed': menu3.state == 'collapsed', 'has-sub': menu3.submenu, 'd-none': menu3.hide }"
                    #rla3="routerLinkActive">
                    <a class="menu-link" *ngIf="menu3.submenu"
                      (click)="(menu3.submenu) ? expandCollapseSubmenu(menu3, menu2.submenu, rla3) : ''">
                      <ng-template *ngTemplateOutlet="sidebarSubMenuNav; context: {menu: menu3}"></ng-template>
                    </a>
                    <a class="menu-link" *ngIf="!menu3.submenu" [routerLink]="menu3.url">
                      <ng-template *ngTemplateOutlet="sidebarSubMenuNav; context: {menu: menu3}"></ng-template>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- BEGIN minify-button -->
      <!-- <div class="menu-item d-flex">
				<a href="javascript:;" (click)="logoutUser()" class="app-sidebar-minify-btn ms-auto"><i class="fa fa-sign-out"></i></a>
			</div> -->
      <!-- END minify-button -->
    </div>
    <!-- END menu -->
  </ng-template>

  <!-- Sidebar Component -->
  <div class="sidebar-user-wrapper">
    <div class="sidebar-user-logo" (click)="toggleDropdown()">
      <div class="sidebar-user-avatar-icon">
        <i class="fa fa-user"></i>
      </div>
    </div>
  </div>

  <!-- User Dropdown - place this outside the sidebar -->
  <div class="user-dropdown" *ngIf="isDropdownVisible" (clickOutside)="closeDropdown()">
    <ul data-bs-theme="dark">
      <li>Profile</li>
      <li>Settings</li>
      <li (click)="logoutUser()">Logout</li>
    </ul>
  </div>

</div>
<div class="app-sidebar-bg" [attr.data-bs-theme]="appSettings.appSidebarLight ? '' : 'dark'"></div>
<div class="app-sidebar-mobile-backdrop">
  <a href="javascript:;" (click)="toggleAppSidebarMobile()" class="stretched-link"></a>
</div>

<!-- END #sidebar -->

<float-sub-menu *ngIf="appSettings.appSidebarMinified" [menus]="appSidebarFloatSubMenu"
  [top]="appSidebarFloatSubMenuTop" [left]="appSidebarFloatSubMenuLeft" [right]="appSidebarFloatSubMenuRight"
  [bottom]="appSidebarFloatSubMenuBottom" [arrowTop]="appSidebarFloatSubMenuArrowTop"
  [arrowBottom]="appSidebarFloatSubMenuArrowBottom" [lineTop]="appSidebarFloatSubMenuLineTop"
  [lineBottom]="appSidebarFloatSubMenuLineBottom" (remainAppSidebarFloatSubMenu)="remainAppSidebarFloatSubMenu()"
  (hideAppSidebarFloatSubMenu)="hideAppSidebarFloatSubMenu()"
  (calculateAppSidebarFloatSubMenuPosition)="calculateAppSidebarFloatSubMenuPosition()"></float-sub-menu>